module.exports = __webpack_public_path__ + "img/candela-hello-world-light.c6f888d8.jpg";